import React from "react";

const CustomDayButton = (props, price, displayPriceIndicator) => {
  const { day, modifiers, ...buttonProps } = props;

  const ref = React.useRef(null);
  React.useEffect(() => {
    if (modifiers.focused) ref.current?.focus();
  }, [modifiers.focused]);

  if (price?.pricingStatus == "low" && displayPriceIndicator) {
    return(
    <button ref={ref} {...buttonProps} className={buttonProps.className + " flex-col"}>
      <div>
        {buttonProps.children}
      </div>
      <div className="h-2 text-center">
        <div className=" w-2 h-2 bg-green-300 rounded-full"></div>
      </div>
    </button>);
  } else {
     return(
    <button ref={ref} {...buttonProps} className={buttonProps.className + " flex-col"}>
      <div>
        {buttonProps.children}
      </div>
      <div className="h-2 text-center">
       </div>
    </button>);
  }

}
export default CustomDayButton;
